module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "navbar top-toolbar navbar-default navbar-fixed-top text-center"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-left"
  }, [_c('li', [_c('button', {
    staticClass: "btn btn-icon sidebar-toggler",
    on: {
      "click": _vm.toggleSidebar
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-bars"
  })])])]), _vm._v(" "), _vm._t("toolbar_buttons"), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', {
    staticClass: "dropdown",
    class: {
      open: _vm.isTimezonesMenuOpen
    }
  }, [_c('button', {
    staticClass: "btn dropdown-toggle",
    on: {
      "click": function($event) {
        _vm.isTimezonesMenuOpen = !_vm.isTimezonesMenuOpen
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" " + _vm._s(_vm.userData.timezone) + "\n                            "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [_c('li', [_c('FormulateInput', {
    attrs: {
      "type": "search"
    },
    on: {
      "input": _vm.getTimezones
    },
    model: {
      value: (_vm.timezoneQuery),
      callback: function($$v) {
        _vm.timezoneQuery = $$v
      },
      expression: "timezoneQuery"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "dropdown-timezones"
  }, [_c('ul', _vm._l((_vm.timezones), function(t) {
    return _c('li', [_c('button', {
      staticClass: "btn btn-link",
      attrs: {
        "disabled": t == _vm.userData.timezone
      },
      on: {
        "click": function($event) {
          return _vm.setTimezone(t)
        }
      }
    }, [(t == _vm.userData.timezone) ? _c('i', {
      staticClass: "fa fa-check",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v(" " + _vm._s(t) + "\n                                        ")])])
  }), 0)])])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown profile",
    class: {
      open: _vm.isMenuOpen
    }
  }, [_c('button', {
    staticClass: "btn dropdown-toggle",
    on: {
      "click": function($event) {
        _vm.isMenuOpen = !_vm.isMenuOpen
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cog",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.activeAccount.name) + "\n                            "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/settings/profile"
    }
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.userData.email) + "\n\t\t                ")])], 1), _vm._v(" "), (_vm.is_admin) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/settings/account"
    }
  }, [_c('i', {
    staticClass: "fa fa-cog",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Settings\n\t\t                ")])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Logout\n\t\t                ")])]), (_vm.userData.accounts.length > 1) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.userData.accounts.length > 1) ? _c('li', {
    staticClass: "account-switcher-wrapper"
  }, [_c('FormulateInput', {
    attrs: {
      "id": "account-switcher-search",
      "type": "search"
    },
    model: {
      value: (_vm.accountFilter),
      callback: function($$v) {
        _vm.accountFilter = $$v
      },
      expression: "accountFilter"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "accounts-menu"
  }, [(_vm.customers.length) ? _c('li', {
    staticClass: "role-title"
  }, [_vm._v("Customers")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.customers), function(a) {
    return _c('li', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.switchAccount(a)
        }
      }
    }, [(a.active == true) ? _c('i', {
      staticClass: "fa fa-check",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v(" " + _vm._s(a.name))])])
  }), _vm._v(" "), (_vm.vendors.length) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.vendors.length) ? _c('li', {
    staticClass: "role-title"
  }, [_vm._v("Vendors")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.vendors), function(a) {
    return _c('li', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.switchAccount(a)
        }
      }
    }, [(a.active == true) ? _c('i', {
      staticClass: "fa fa-check",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v(" " + _vm._s(a.name))])])
  })], 2)], 1) : _vm._e()])])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "section-content container-fluid",
    attrs: {
      "id": "main-container"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._t("main")], 2)]), _vm._v(" "), _vm._t("modals")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bb7af0e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/BaseLayout.vue
// module id = 668
// module chunks = 0